export default __webpack_public_path__ + "static/blockchain-52ba2e37c4c6b1751fd7591325d74c17.png";